import { F5Logo } from '@platform/components';
import { OrgUserNextBestActionResponse } from 'lib/client/src/platformapi.schemas';
import MovingWorldsCompassLogo from '../../layout/MovingWorldsCompassLogo';
import { ROUTES } from '../../routes/consts';
import { GenericNBACard, NextBestActionCard, NextBestActionCardProps } from './NextBestActionCard';
const OrgUserNextBestActions = ({
  cardsToDisplay = 3,
  ...props
}: OrgUserNextBestActionResponse & {
  cardsToDisplay?: number;
}) => {
  const {
    connectWithProfessional,
    createProject,
    inviteColleague,
    respondToIntroductionAction,
    continueTracking,
    learnF5,
    businessNeeds,
    completeOnboarding,
  } = props;

  const orgUserCards: (NextBestActionCardProps | boolean)[] = [
    !!respondToIntroductionAction && {
      engagmentActionId: 'respond_to_introduction_action',
      content:
        'You have an introduction from an Experteer. Respond today to learn more about how they can support your organization.',
      linkText: 'Respond today',
      linkUrl: `/platform/dashboard${ROUTES.MY_PROJECTS}?introductionId=${respondToIntroductionAction.introductionId}`,
      actualUrl: `/platform/dashboard${ROUTES.MY_PROJECTS}?introductionId=${respondToIntroductionAction.introductionId}`,
      estimatedTime: '3 minutes',
      canDismiss: true,
      leftBorder: true,
    },
    !!completeOnboarding && {
      engagmentActionId: 'onboarding_video',
      content: 'Watch our welcome video.',
      linkText: 'Watch Welcome Video',
      linkUrl: completeOnboarding.videoUrl,
      actualUrl: completeOnboarding.videoUrl,
      estimatedTime: '5 minutes',
      canDismiss: true,
      leftBorder: true,
    },
    businessNeeds && {
      engagmentActionId: 'business_needs',
      content: 'Tell us what challenges your organization is facing for custom guidance.',
      linkText: 'Get started',
      linkUrl: `/platform${ROUTES.BUSINESS_CHALLENGES}`,
      actualUrl: `/platform${ROUTES.BUSINESS_CHALLENGES}`,
      estimatedTime: '5 minutes',
      canDismiss: true,
      leftBorder: true,
    },
    // assessment && {
    //   engagmentActionId: 'assessment',
    //   content:
    //     'Take our scale-up assessment to identify where you should focus your company building efforts to grow your impact & revenues.',
    //   linkText: 'Take the Scale-Up Assessment',
    //   linkUrl: `${import.meta.env['VITE_LEGACY_APP_URL']}/scaleup-assessment`,
    //   actualUrl: `${import.meta.env['VITE_LEGACY_APP_URL']}/scaleup-assessment`,
    //   estimatedTime: '5 minutes',
    //   canDismiss: true,
    //   leftBorder: true,
    // },
    createProject && {
      engagmentActionId: 'create_project',
      content: 'Request pro-bono support to accelerate and grow your impact.',
      linkText: 'Request pro-bono support',
      linkUrl: '/platform/create-project',
      actualUrl: '/platform/create-project',
      estimatedTime: '10 minutes',
      canDismiss: true,
      leftBorder: true,
    },
    connectWithProfessional && {
      engagmentActionId: 'connect_with_professional',
      content: 'Browse and connect with the network of Experteers that want to support your cause.',
      linkText: 'Browse and connect',
      linkUrl: `/platform/user-search`,
      actualUrl: `/platform/user-search`,
      estimatedTime: '5 minutes',
      canDismiss: true,
      leftBorder: true,
    },
    !!inviteColleague && {
      engagmentActionId: 'invite_colleague',
      content: 'Invite a team member to collaborate on learning and managing projects.',
      linkText: 'Invite a team member',
      linkUrl: `/platform${ROUTES.INVITE_ORG_COLLEAGUE}`,
      actualUrl: `/platform${ROUTES.INVITE_ORG_COLLEAGUE}`,
      estimatedTime: '2 minutes',
      canDismiss: true,
      leftBorder: true,
    },
  ];

  const filteredOrgUserCards = orgUserCards.filter(Boolean) as NextBestActionCardProps[];

  return (
    // These are 'static' cards displayed regardless of user 'action'
    <div className='flex flex-col gap-4'>
      {continueTracking && (
        <GenericNBACard
          description='Get the execution support you need, at every stage of growth.'
          logo={
            <div className='text-brand-500'>
              <MovingWorldsCompassLogo />
            </div>
          }
          leftBorder
          avatarSize='md'
        />
      )}
      {learnF5 && (
        <GenericNBACard
          description="Learn about F5's Volunteer Sprint program"
          linkText='Read more'
          linkUrl='/partner/F5/volunteer-sprint-nonprofits'
          logo={<F5Logo />}
        />
      )}
      {/* User activity determined NBAs */}
      {filteredOrgUserCards.map(
        (card, index) =>
          index < cardsToDisplay &&
          sessionStorage.getItem(card.engagmentActionId) !== 'dismissed' && (
            <NextBestActionCard key={card.engagmentActionId} {...card} />
          ),
      )}
    </div>
  );
};

export default OrgUserNextBestActions;
